import * as React from 'react';
import { type Controlled_StringInputProps } from '../../../../../../../react-commons/components/inputs/controlled/Controlled_StringInput';
import { ControlledInputs } from '../../../../../../../react-commons/utils/read-only-inputs/controlledInputs';
import { usePropertyInfo } from '../../../../hooks/usePropertyInfo';
import { type PropertyValidationInformation } from '../../../../util/PropertyValidationInformation';

export const Controlled_PropertyNameInput = ({
    readOnly,
    labelOverride,
    propertyValidationInformation: { propertyIdentifier, resourceType, resourceId },
    hideLabel,
    ...props
}: Omit<
    Controlled_StringInputProps<false>,
    'nullable' | 'label' | 'labelInfo' | 'severity' | 'helperText' | 'endingIcon'
> & {
    labelOverride?: string;
    propertyValidationInformation: PropertyValidationInformation;
    hideLabel?: boolean;
}) => {
    const propertyInfo = usePropertyInfo({
        propertyIdentifier,
        resourceType,
        resourceId,
        hideLabel,
        labelOverride,
        readOnly,
    });

    return (
        <ControlledInputs.String
            nullable={false}
            {...propertyInfo}
            {...props}
            helperText={propertyInfo.helperText ? [propertyInfo.helperText] : undefined}
        />
    );
};
